<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">库存信息</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-table ref="table2" class="table" size="mini" :loading="loading" :data="stockinInfo" :height="300" border>

          <el-table-column prop="waresName" label="物品名称"></el-table-column>
          <el-table-column prop="remarks" label="入库批次"></el-table-column>
          <el-table-column prop="count" label="入库数量"></el-table-column>
          <el-table-column prop="outCount" label="出库数量"></el-table-column>
          <el-table-column prop="expiresTime" label="过期时间" :formatter="timefilter"></el-table-column>
        </el-table>

      </div>
<!--      <div class="modal-footer">-->
<!--        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>-->
<!--      </div>-->
    </div>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",

  data(){
    return{
      loading:false,


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,


      waresCode:'',
      stockinInfo:[],

    }
  },
  components:{

  },
  methods:{

    init(row){
      this.waresCode = row.waresCode;

      this.stockInfo();
    },

    closeSelf(){
      this.$emit("closeInfo");
    },

    stockInfo(){

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Wares/StockInInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          waresCode:this.waresCode,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.stockinInfo = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },


    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,10)
    },


  }

}
</script>

<style scoped>

</style>
